/**
 * YG Baby Name Dialog controller.
 * Standalone clone of DSM dialog open/close behavior for Baby Name lead dialogs.
 * Does not depend on dsm-components.js / DsmDialog.
 *
 * API:
 *   YgBabyNameDialog.open('baby-name-lead-form')
 *   YgBabyNameDialog.close('baby-name-lead-form')
 *
 * HTML trigger:
 *   <button data-yg-bn-dialog-open="my-dialog">Open</button>
 *
 * Events (on overlay, bubbles):
 *   baby-name:dialog:open
 *   baby-name:dialog:close
 *   baby-name:dialog:confirm  (cancelable — preventDefault keeps dialog open)
 *   baby-name:dialog:cancel
 */
;(function (root) {
  if (!root || !root.document) return

  var doc = root.document
  var _activeOverlay = null
  var _previousFocus = null

  function _getFocusable(container) {
    return Array.prototype.slice
      .call(
        container.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), ' +
            'select:not([disabled]), textarea:not([disabled]), ' +
            '[tabindex]:not([tabindex="-1"])'
        )
      )
      .filter(function (el) {
        return !el.closest('[hidden]') && !el.closest('[aria-hidden="true"]')
      })
  }

  function _trapFocus(e) {
    if (!_activeOverlay || e.key !== 'Tab') return
    var focusable = _getFocusable(_activeOverlay)
    if (!focusable.length) {
      e.preventDefault()
      return
    }
    var first = focusable[0]
    var last = focusable[focusable.length - 1]
    var active = doc.activeElement
    var activeInside = _activeOverlay.contains(active)

    // If focus escaped the overlay (plugin/script), pull it back on Tab.
    if (!activeInside) {
      e.preventDefault()
      ;(e.shiftKey ? last : first).focus()
      return
    }

    if (e.shiftKey) {
      if (active === first) {
        e.preventDefault()
        last.focus()
      }
    } else if (active === last) {
      e.preventDefault()
      first.focus()
    }
  }

  function _onKeydown(e) {
    if (e.key === 'Escape' && _activeOverlay) {
      var id = _activeOverlay.getAttribute('data-yg-bn-dialog')
      _activeOverlay.dispatchEvent(new root.CustomEvent('baby-name:dialog:cancel', { bubbles: true }))
      close(id)
    }
    _trapFocus(e)
  }

  function _onOverlayClick(e) {
    if (e.target !== e.currentTarget) return
    if (e.currentTarget.hasAttribute('data-yg-bn-no-overlay-close')) return
    var id = e.currentTarget.getAttribute('data-yg-bn-dialog')
    e.currentTarget.dispatchEvent(new root.CustomEvent('baby-name:dialog:cancel', { bubbles: true }))
    close(id)
  }

  function open(id) {
    var triggerEl = doc.activeElement
    var overlay = doc.querySelector('[data-yg-bn-dialog="' + id + '"]')
    if (!overlay) {
      if (root.console && root.console.warn) {
        root.console.warn('[YgBabyNameDialog] No dialog found with id: "' + id + '"')
      }
      return
    }

    _previousFocus = triggerEl && triggerEl !== doc.body ? triggerEl : doc.activeElement
    doc.documentElement.classList.add('yg-bn-dialog-scroll-lock')
    overlay.classList.add('is-open')
    _activeOverlay = overlay

    var focusable = _getFocusable(overlay)
    if (focusable.length) {
      var closeBtn = overlay.querySelector('.yg-bn-dialog__close')
      ;(closeBtn || focusable[0]).focus()
    }

    doc.addEventListener('keydown', _onKeydown)
    overlay.addEventListener('click', _onOverlayClick)
    overlay.dispatchEvent(new root.CustomEvent('baby-name:dialog:open', { bubbles: true }))
  }

  function close(id) {
    var overlay = doc.querySelector('[data-yg-bn-dialog="' + id + '"]')
    if (!overlay) return
    overlay.classList.remove('is-open')
    if (_activeOverlay === overlay) _activeOverlay = null
    doc.documentElement.classList.remove('yg-bn-dialog-scroll-lock')
    doc.removeEventListener('keydown', _onKeydown)
    overlay.removeEventListener('click', _onOverlayClick)
    if (_previousFocus && typeof _previousFocus.focus === 'function' && _previousFocus.isConnected !== false) {
      _previousFocus.focus()
    }
    _previousFocus = null
    overlay.dispatchEvent(new root.CustomEvent('baby-name:dialog:close', { bubbles: true }))
  }

  function init() {
    doc.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-yg-bn-dialog-open]')
      if (!trigger) return
      e.preventDefault()
      open(trigger.getAttribute('data-yg-bn-dialog-open'))
    })

    doc.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-yg-bn-dialog-confirm')
      if (!btn || btn.disabled) return
      var overlay = btn.closest('[data-yg-bn-dialog]')
      if (!overlay) return
      var id = overlay.getAttribute('data-yg-bn-dialog')
      // cancelable: listeners may preventDefault() to keep the dialog open (validation errors).
      var confirmEvt = new root.CustomEvent('baby-name:dialog:confirm', {
        bubbles: true,
        cancelable: true,
      })
      overlay.dispatchEvent(confirmEvt)
      if (!confirmEvt.defaultPrevented) close(id)
    })

    doc.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-yg-bn-dialog-cancel')
      if (!btn) return
      var overlay = btn.closest('[data-yg-bn-dialog]')
      if (!overlay) return
      overlay.dispatchEvent(new root.CustomEvent('baby-name:dialog:cancel', { bubbles: true }))
      close(overlay.getAttribute('data-yg-bn-dialog'))
    })
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }

  root.YgBabyNameDialog = { open: open, close: close }
})(typeof window !== 'undefined' ? window : null)
